// The record a send keeps for retry, the watchdog and the in-flight scaffold:
// exactly what was posted. A retry re-sends this record (same cid, text and
// media), never the composer's current draft or attachment.
import type { ChatMedia } from './protocol.ts';

export type SendRecord = { text: string; cid: string; media?: ChatMedia };

export const makeRecord = (
  text: string,
  cid: string,
  media: ChatMedia | null,
): SendRecord => ({ text, cid, ...(media ? { media } : {}) });

// The POST /chat body for a record. Only a freshly uploaded attachment carries
// `key`; hydrated history media (no key) is never re-submitted.
export const chatBody = (record: SendRecord, threadId: string) => ({
  message: record.text,
  thread_id: threadId,
  client_msg_id: record.cid,
  ...(record.media && record.media.key
    ? { media: { key: record.media.key, mime: record.media.mime } }
    : {}),
});

// What the in-flight scaffold stores in localStorage: the record with media
// reduced to {key, mime} (what chatBody sends), never the time-limited signed
// url of an upload.
export const inflightJson = (record: SendRecord): string =>
  JSON.stringify({
    text: record.text,
    cid: record.cid,
    ...(record.media && record.media.key
      ? { media: { key: record.media.key, mime: record.media.mime } }
      : {}),
  });
